<template>
  <div class="login-form">
    <div class="form border">
      <h1 v-if="isSport > 0">{{ $lang("TEXT_SPORT_LOGIN") }}</h1>
      <h1 v-else>{{ $lang("TEXT_OTHER_LOGIN") }}</h1>
      <p v-if="errmsg" class="text-center " style="color: #a94442; font-size: 14px;">
        {{ errmsg }}
      </p>
      <b-form @submit="onSubmit">
        <div class="row" style="margin: 0px 50px">
          <div v-if="isSport > 0" @click="loginForm.loginType = 'username'" :class="loginForm.loginType == 'username'
            ? `col-6 px-0 login-type-active `
            : `col-6 px-0 login-type`
            ">
            {{ $lang("會員賬號") }}
          </div>
          <div v-if="isSport > 0" @click="loginForm.loginType = 'mobile'" :class="loginForm.loginType == 'mobile'
            ? `col-6 px-0 login-type-active `
            : `col-6 px-0 login-type`
            ">
            {{ $lang("手機登入") }}
          </div>
        </div>
        <!-- <b-form-radio-group
          v-if="isSport > 0"
          style="margin: 0px 50px"
          v-model="loginForm.loginType"
          plain
          name="plain-inline"
        >
          <b-form-radio value="username">{{ $lang("會員賬號") }}</b-form-radio>
          <b-form-radio value="mobile">{{ $lang("手機登入") }}</b-form-radio>
        </b-form-radio-group> -->
        <div>
          <b-form-group class="phone">
            <template slot="label">
              <label></label>
            </template>
            <b-form-input v-model="loginForm.mobile" type="text" name="phone"
              :class="errors.has('phone') && 'is-invalid'" :placeholder="$lang('FIELD_PHONE')"
              v-validate="{ required: !status, mobile: !status }"></b-form-input>
            <b-form-invalid-feedback :state="errors.has('phone')">
              {{ errors.first("phone") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="user_name">
            <template slot="label">
              <label></label>
            </template>
            <!-- 證件類型 -->
            <b-form-select v-model="loginForm.idType" ph name="idType" :class="errors.has('idType') && 'is-invalid'"
              v-validate="{ required: requiredType }" :placeholder="$lang('TITLE_ID_TYPE')">
              <option :value="null" disabled hidden>{{ $lang('TITLE_ID_TYPE') }}</option>
              <option :value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
              <option :value="2">{{ $lang("TEXT_ID_TYPE_PASSPORT") }}</option>
              <option :value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
            </b-form-select>
            <b-form-invalid-feedback :state="errors.has('idType')">
              {{ errors.first("idType") }}
            </b-form-invalid-feedback>

          </b-form-group>
          <b-form-group class="user_name">
            <template slot="label">
              <label></label>
            </template>
            <b-form-input maxlength="4" v-model="loginForm.idNum4" type="text" name="idNum4"
              :class="errors.has('idNum4') && 'is-invalid'" :placeholder="`${$lang('身份證號碼')}(${$lang('最後4位數字')})`"
              v-validate="{ required: !status }"></b-form-input>
            <b-form-invalid-feedback :state="errors.has('idNum4')">
              {{ errors.first("idNum4") }}
            </b-form-invalid-feedback>
          </b-form-group>


          <div v-if="mbCode != null" style="margin: 0px 50px">
            {{ $lang(`測試手機驗證碼:${this.mbCode}`) }}
          </div>
          <b-form-group class="verification authentication">
            <template slot="label">
              <label></label>
            </template>
            <b-form-input v-model="loginForm.smsCode" type="text" @change="checkCode" :state="codeState" name="code"
              :class="errors.has('code') && 'is-invalid'" :placeholder="$lang('FIELD_VERIFICATION')"
              v-validate="{ required: !status }"></b-form-input>
            <b-btn variant="info" @click="getCode" :disabled="disabled">
              <b-overlay :show="codeLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
                style="top: 10px"></b-overlay>
              <span class="tip" v-if="!sendMsgDisabled && !reGet">{{
                $lang("發送驗證碼")
                }}</span>
              <span class="tip" v-if="!sendMsgDisabled && reGet">{{
                $lang("重新獲取")
                }}</span>
              <span class="tip" v-if="sendMsgDisabled">{{
                rTime + $lang("秒後重新獲取")
                }}</span>
            </b-btn>
            <b-form-invalid-feedback :state="errors.has('code')">
              {{ errors.first("code") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="captcha">
            <b-form-input v-model="loginForm.captcha" name="captcha" :class="errors.has('captcha') && 'is-invalid'"
              :placeholder="$lang('FILED_CAPTCHA')" v-validate="'required'"></b-form-input>
            <div class="captcha-invalid">
              <b-img :src="captcha_url"></b-img>
              <!-- {{$lang('Renew')}} -->
              <a href="javascript:void(0)" class="reload_btn" @click="getCaptcha()"></a>
            </div>
            <!-- <template slot="label">
                    
                </template> -->
            <b-form-invalid-feedback :state="errors.has('captcha')">
              {{ errors.first('captcha') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-button type="submit" class="login" variant="primary">{{
            $lang("TEXT_LOGIN")
            }}</b-button>
          <b-button class="login my-0" style="background: #a2bcce" variant="primary">
            <b-link style="color: #ffffff; text-decoration: none" to="register">{{ $lang("TEXT_GO_TO_REGISTE")
            }}</b-link></b-button>
        </div>
      </b-form>
      <div class="clearfix">
        <b-link class="back" :to="{ name: 'home' }">{{
          $lang("TITLE_RETURN_INDEX")
          }}</b-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LaddaBtn from "@/components/ladda/Ladda";
export default {
  components: {
    LaddaBtn,
  },
  data() {
    return {
      errmsg: "",
      rTime: 60,
      sendMsgDisabled: false, // 发送验证码按钮状态
      reGet: false, // 重新获取
      codeState: null,
      disabled: false,
      interval: null,
      loginForm: {
        idType: 1,
        mobile: "",
        idNum4: "",
        username: "",
        captcha: null,
        password: "",
        loginType: "mobile",
        scene: "login"
      },
      codeLoading: false,
      mbCode: null,
      loginLoading: false,
      requiredType: true
    };
  },
  computed: {
    sportResetUrl() {
      return this.$store.state.base.sportResetUrl;
    },
    changeLocale() {
      return this.$getLocale();
    },
    ...mapGetters("user", {
      captcha: "captcha",
      captcha_url: "captcha_url",
      sid: "sid",
    }),
    status() {
      return this.loginForm.loginType === "username";
    },
    isSport() {
      return Number(this.$route.query.isSport) || 0;
    },
  },
  methods: {
    ...mapActions("user", ["login", "getCaptcha", ""]),
    checkCode() {
      // let params = {
      //     mobile: this.registerForm.mobile,
      //     code: this.registerForm.code,
      //     scene: this.registerForm.scene
      // }
      // this.$apis.checkCode(params).then(() => {
      //     this.codeState = true
      // }).catch((err) => {
      //     this.errors.add({
      //         field: "verificationCode",
      //         msg: this.$lang(err.code)
      //     })
      // })
    },
    //驗證碼

    sendCode(params) {
      return this.$apis.phoneCode(params);
    },
    // getCode() {
    //   this.$validator.validate("phone").then((valid) => {
    //     if (valid) {
    //       this.$validator.validate("idNum4").then((idValid) => {
    //         if (idValid) {
    //           this.codeLoading = true;
    //           let rTime = this.rTime;
    //           this.sendMsgDisabled = true;
    //           this.disabled = true;
    //           let params = {
    //             mobile: this.loginForm.mobile,
    //             idNum4: this.loginForm.idNum4,
    //           };
    //           this.sendCode(params)
    //             .then((res) => {
    //               console.log(res);
    //               this.codeLoading = false;
    //               if (res.data.code) {
    //                 this.mbCode = res.data.code;
    //               }

    //               this.interval = setInterval(() => {
    //                 if (--this.rTime <= 0) {
    //                   this.rTime = rTime;
    //                   this.sendMsgDisabled = false;
    //                   this.disabled = false;
    //                   this.reGet = true; // 重新获取按钮
    //                   clearInterval(this.interval);
    //                 }
    //               }, 1000);
    //             })
    //             .catch((err) => {
    //               this.sendMsgDisabled = false;
    //               this.disabled = false;
    //               this.codeLoading = false;
    //               clearInterval(this.interval);
    //               this.reGet = true; // 重新获取按钮
    //               this.notification.error(this.$lang(err.message));
    //             });
    //           //倒计时
    //         }
    //       });
    //     }
    //   });
    // },
    getCode() {
      this.$validator.validate("phone").then((valid) => {
        if (valid) {
          this.$validator.validate("idNum4").then((idValid) => {
            if (idValid) {
              this.codeLoading = true;
              let rTime = this.rTime;
              this.sendMsgDisabled = true;
              this.disabled = true;
              let params = {
                mobile: this.loginForm.mobile,
                scene: this.loginForm.scene,
              };
              this.$apis.sendCode(params)
                .then((res) => {
                  // console.log(res);
                  this.codeLoading = false;
                  if (res.data.code) {
                    this.mbCode = res.data.code;
                  }

                  this.interval = setInterval(() => {
                    if (--this.rTime <= 0) {
                      this.rTime = rTime;
                      this.sendMsgDisabled = false;
                      this.disabled = false;
                      this.reGet = true; // 重新获取按钮
                      clearInterval(this.interval);
                    }
                  }, 1000);
                })
                .catch((err) => {
                  this.sendMsgDisabled = false;
                  this.disabled = false;
                  this.codeLoading = false;
                  clearInterval(this.interval);
                  this.reGet = true; // 重新获取按钮
                  this.notification.error(this.$lang(err.message));
                });
              //倒计时
            }
          });
        }
      });
    },

    onSubmit(evt) {
      console.log(this.status);
      evt.preventDefault();
      // 以前的参数
      // let params = { ...this.loginForm, isSport: this.isSport, sid: this.sid };
      const params = {
        mobile: this.loginForm.mobile,
        idType: this.loginForm.idType,
        idNum4: this.loginForm.idNum4,
        smsCode: this.loginForm.smsCode,
        sid: this.sid,
        captcha: this.loginForm.captcha,
      }

      this.errmsg = "";
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loginLoading = true;
          this.login(params)
            .then((resp) => {
              this.errmsg = "";
              this.loginLoading = false;
              this.notification.success(this.$lang("登入成功"));
              localStorage.setItem("application-token", resp.data.token);
              this.$router.replace({
                name: "account",
              });
            })
            .catch((err) => {
              console.log(err)
              if (err.code == 10009) {
                this.errors.add({
                  field: "code",
                  // msg: this.$lang(`${err.message}`),
                  msg: this.$lang("驗證碼不正確"),
                });
              }
              if (err.code == 10003) {
                this.errors.add({
                  field: "captcha",
                  msg: this.$lang("驗證碼不正確"),
                });
                this.getCaptcha();
              } else if (err.code == 10009) {
                this.errors.add({
                  field: "password",
                  msg: this.$lang("密碼不正确"),
                });
                this.getCaptcha();
              } else if (err.code == 10007) {
                this.errors.add({
                  field: "idNum4",
                  msg: this.$lang("賬號不存在"),
                });
                this.getCaptcha();
              } else if (err.code == 10010) {
                // 调转到验证邮箱界面, 賬戶未驗證
                this.$router.push({
                  name: "waiting_confirm_mail",
                  params: {
                    hash: err.data.hash,
                  },
                });
              } else {
                this.errmsg = this.$lang(err.message);
                this.getCaptcha();
              }
            });
        } else {
          console.log("验证失败的字段：", this.errors.items);
          console.log('valid', valid)
          return false;
        }
      });
    },
  },
  watch: {
    changeLocale(n) {
      this.errmsg = "";
    },
    "loginForm.loginType": {
      handler(n) {
        (this.loginForm = {
          mobile: "",
          idNum4: "",
          username: "",
          captcha: null,
          password: "",
          loginType: n,
        }),
          this.$validator.reset();
      },
    },
  },
  created() {
    this.getCaptcha();
  },
};
</script>
